import { __awaiter } from "tslib";
import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import { RESPONSE_STATUS_CODES } from '@/constants/serverConstants';
const networksRules = {};
function tryFindNetwork(address) {
    const matchesArray = Object.entries(networksRules).reduce((arr, curr) => {
        const [key, value] = curr;
        if (value(address))
            arr.push(key);
        return arr;
    }, []);
    if (matchesArray.length) {
        return matchesArray.length === 1
            ? 'TRX'
            : 'BSC';
    }
    else
        return false;
}
export default Vue.extend({
    name: 'whitelistsCreateAddress',
    props: {
        secretCodeExist: {
            type: Boolean,
            required: true
        },
        availableNetworks: {
            type: Array,
            required: true
        },
        walletsList: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
            form: {
                valid: false,
                fields: {
                    name: '',
                    value: '',
                    network: 'chooseNetwork'
                },
                rules: {
                    name: [
                        (v) => Boolean(v.length) || 'Поле обязательно'
                    ],
                    value: [
                        (v) => Boolean(v.length) || this.$t('whitelistsPage.errors.fieldIsRequired'),
                        (v) => {
                            return Boolean(tryFindNetwork(v)) || this.$t('whitelistsPage.errors.addressDoesntRespondAnyNetwork');
                        }
                    ]
                }
            }
        };
    },
    computed: {
        networkValue() {
            return this.form.fields.network === 'chooseNetwork' ? this.$t('whitelistsPage.chooseNetwork') : this.form.fields.network;
        },
        letSelectNetwork() {
            const address = this.form.fields.value;
            if (address.length) {
                return Boolean(this.availableNetworks.filter((item) => networksRules[item.key](address)).length);
            }
            return false;
        }
    },
    filters: {
        parseAvailableNetworks(value, address) {
            return value.map((item) => ({
                key: item.key,
                value: item.label,
                isActive: networksRules[item.key](address)
            }));
        }
    },
    watch: {
        'form.fields.value'(newValue) {
            const network = tryFindNetwork(newValue);
            this.form.fields.network = network || 'chooseNetwork';
        },
        availableNetworks() {
            this.updateNetworkRules();
        }
    },
    methods: {
        closeCreateAddress() {
            const vm = this;
            vm.$emit('changeAsideMode', 'default');
        },
        handleClickConfirm() {
            const vm = this;
            function handleForcedSave(secret) {
                return __awaiter(this, void 0, void 0, function* () {
                    vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                    const response = yield vm.services.mainService.whitelistCreateWallet({
                        walletSecret: secret,
                        name: vm.form.fields.name,
                        address: vm.form.fields.value,
                        network: vm.form.fields.network,
                        forceCreate: true
                    });
                    if (response.success) {
                        vm.$emit('onSuccess');
                        vm.$store.dispatch('alertsBus/openAlert', {
                            title: vm.$t('whitelistsPage.alerts.titles.success'),
                            type: 'success',
                            autoDelete: true,
                            messages: [vm.$t('whitelistsPage.alerts.content.walletAdded', { name: vm.form.fields.name })]
                        });
                        vm.$emit('onAddAddressSuccess');
                        vm.$store.commit('popupModule/setClosed');
                        vm.$emit('changeAsideMode', 'default');
                    }
                    else {
                        vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                        for (const [key, val] of Object.entries(response.data)) {
                            const isSecretKeyInvalid = `${val}` === 'invalid';
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('whitelistsPage.alerts.titles.error'),
                                type: 'error',
                                autoDelete: true,
                                content: isSecretKeyInvalid ? 'Неверный секретный код' : `${key}: ${val}`
                            });
                        }
                    }
                });
            }
            vm.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: vm.$t('whitelistsPage.popups.titles.confirmOperation'),
                content: vm.$t('whitelistsPage.popups.content.enterSecretCodeToAddWallet', { name: vm.form.fields.name }),
                actions: [],
                slot: {
                    name: 'confirmActionPopupChunk',
                    data: {
                        secretCodeExist: vm.secretCodeExist,
                        isLoading: false
                    },
                    on: {
                        onConfirm(secret) {
                            return __awaiter(this, void 0, void 0, function* () {
                                vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                                const response = yield vm.services.mainService.whitelistCreateWallet({
                                    walletSecret: secret,
                                    name: vm.form.fields.name,
                                    address: vm.form.fields.value,
                                    network: vm.form.fields.network
                                });
                                if (response.success) {
                                    if (response.status === RESPONSE_STATUS_CODES.ACCEPTED) {
                                        vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                                        const matchedWallet = response.data[0];
                                        vm.$store.dispatch('popupModule/openPopup', {
                                            type: ActivePopupTypes.action,
                                            letDefaultClose: false,
                                            title: vm.$t('whitelistsPage.popups.titles.createWallet', { name: vm.form.fields.name }),
                                            content: vm.$t('whitelistsPage.popups.content.addressRespondWithExistAddress', { matchedWallet: matchedWallet.name, name: vm.form.fields.name }),
                                            actions: [],
                                            slot: {
                                                name: 'confirmWhitelistRepeat',
                                                data: {
                                                    isLoading: false
                                                },
                                                on: {
                                                    onConfirm() {
                                                        return __awaiter(this, void 0, void 0, function* () {
                                                            handleForcedSave(secret);
                                                        });
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    else {
                                        vm.$emit('onSuccess');
                                        vm.$store.dispatch('alertsBus/openAlert', {
                                            title: vm.$t('whitelistsPage.alerts.titles.success'),
                                            type: 'success',
                                            autoDelete: true,
                                            messages: [vm.$t('whitelistsPage.alerts.content.walletAdded', { name: vm.form.fields.name })]
                                        });
                                        vm.$emit('onAddAddressSuccess');
                                        vm.$store.commit('popupModule/setClosed');
                                        vm.$emit('changeAsideMode', 'default');
                                    }
                                }
                                else {
                                    vm.$store.dispatch('alertsBus/openAlert', {
                                        title: 'Ошибка',
                                        type: 'error',
                                        autoDelete: true,
                                        content: response.data.errors.join('\n')
                                    });
                                    // for (const [key, val] of Object.entries(response.data)) {
                                    //   const isSecretKeyInvalid = `${val}` === 'invalid'
                                    //   vm.$store.dispatch('alertsBus/openAlert', {
                                    //     title: 'Ошибка',
                                    //     type: 'error',
                                    //     autoDelete: true,
                                    //     content: isSecretKeyInvalid ? 'Неверный секретный код' : `${key}: ${val}`
                                    //   })
                                    // }
                                    vm.$emit('onAddAddressSuccess');
                                    vm.$store.commit('popupModule/setClosed');
                                }
                            });
                        },
                        onClickBeginCreateSecret() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.$emit('onClickBeginCreateSecret');
                        },
                        onClickBeginReset() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.$emit('onClickBeginReset');
                        }
                    }
                }
            });
        },
        updateNetworkRules() {
            this.availableNetworks.forEach((item) => {
                networksRules[item.key] = (v) => {
                    const reg = new RegExp(item.rule);
                    return reg.test(v);
                };
            });
        }
    },
    created() {
        this.updateNetworkRules();
    }
});
